import React from 'react';
import { MonitoringPaper } from './MonitoringPaper';

import './index.scss';
import { Button } from 'antd';

export const EventRanking = ({
  headerIcon,
  headerTitle,
  headerSubTitle,
  children,
  onToggleAll,
  footerText,
  showAll,
  hasMore,
}) => {
  return (
    <MonitoringPaper
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div className="event-ranking-header">
        <div className="event-ranking-header-left">
          <span className="event-ranking-header-icon">{headerIcon}</span>
          <span className="event-ranking-header-title">{headerTitle}</span>
        </div>
        <div className="event-ranking-header-right">
          <div className="event-ranking-header-subtitle">{headerSubTitle}</div>
        </div>
      </div>
      <div className="event-ranking-content" style={{ flex: 1 }}>
        {children}
      </div>
    </MonitoringPaper>
  );
};
